// Also used on homepage
app.controller('header', ['$scope', '$http', '$timeout', function ($scope, $http, $timeout) {
  $scope.searchingByLocation = false;
  $scope.locationFailed = true;
  $scope.searchQuery = '';
  $scope.searchType = 'location';
  $scope.placeholders = {
    'location' : 'Enter postcode or town',
    'firm' : 'Enter firm name',
    'adviser' : 'Enter adviser name'
  }

  if (typeof navigator.permissions != 'undefined') {
    navigator.permissions.query({'name': 'geolocation'})
    .then(function (permission) {
      if (permission.state == 'denied') {
        $scope.locationFailed = true;
        $scope.$digest();
      } else {
        $scope.locationFailed = false;
        $scope.$digest();
      }
    });
  } else {
    $scope.locationFailed = false;
  }

  $scope.getLocation = function () {
    if (!navigator.geolocation) {
      alert("Sorry, Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition($scope.locationSuccess, $scope.locationError);
  };

  $scope.locationSuccess = function (position) {
    var latitude  = position.coords.latitude;
    var longitude = position.coords.longitude;

    document.getElementById('lat').value = latitude;
    document.getElementById('lon').value = longitude;

    document.getElementById('location-search').submit();
  };

  $scope.locationError = function () {
    $scope.locationFailed = true;
    $scope.$digest();
    alert('Sorry, Geolocation is not supported by your browser.');
  };
}]);
